import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f205ae96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frame optincontainer" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = { class: "language-switcher" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "intro" }
const _hoisted_8 = { class: "unknown-hint" }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }

import { computed, ref, onMounted } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";
import Cookies from "js-cookie";
import { get } from "lodash-es";
import Optin from "../Optin";
import VueButton from "../components/Button.vue";
import VueGroep from "../components/Groep.vue";
import RingLoader from "../components/RingLoader.vue";
import {
  CommunicatieMedium,
  communicatieMedia,
  OptInKeuze,
  PermissieViewModel,
  RelatieViewModel,
  OptInViewModel,
  RelatieType,
} from "../TypeScriptModels";


export default /*#__PURE__*/_defineComponent({
  __name: 'Optin',
  props: {
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const globalI18n = useI18n({ useScope: "global" });
const i18n = useI18n();
const { t } = i18n;



const loading = ref<boolean>(false);
const haserror = ref<boolean>(false);
const saving = ref<boolean>(false);
const issaved = ref<boolean>(false);
const optin = ref<OptInViewModel>(Optin);
const nietBenaderen = ref<boolean | null>(null);
const relatieType = ref<RelatieType | null>(null);
const languageOptions = [
  { locale: "nl-NL", label: "Nederlands", flag: "/flag_nl.png" },
  { locale: "de-DE", label: "Deutsch", flag: "/flag_de.png" },
  { locale: "fr-FR", label: "Francais", flag: "/flag_fr.svg" },
  { locale: "da-DK", label: "Dansk", flag: "/flag_dk.png" },
  { locale: "en-UK", label: "English", flag: "/flag_uk.png" },
];

onMounted(async () => {
  const localeCookie = Cookies.get("SettingsLocale");
  if (!!localeCookie) {
    switchUserLang(localeCookie);
  } else {
    switchUserLang(navigator.language);
  }

  await loadPage();
});

const showLoading = computed<boolean>(() => {
  return (loading.value || saving.value) && !haserror.value;
});

const showError = computed<boolean>(() => {
  return haserror.value;
});

function switchLang(locale: string) {
  Cookies.set("SettingsLocale", locale);
  globalI18n.locale.value = locale;
  document.title = t("pagetitle");
}

async function loadPage() {
  try {
    if (!loading.value && !!props.id) {
      loading.value = true;

      const url = `/api/consumersettings/v1/optin/relatie`;

      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + props.id,
        },
      });
      optin.value = response.data.Optin;
      relatieType.value = response.data.RelatieType;
      nietBenaderen.value = response.data.NietBenaderen;
      if (!!response.data.Taal) switchUserLang(response.data.Taal);
    }
  } catch (error) {
    console.log(error);
    haserror.value = true;
  } finally {
    loading.value = false;
  }
}

function switchUserLang(locale: string) {
  switch (locale) {
    case "nl":
    case "nl-NL":
    case "nl-BE":
      switchLang("nl-NL");
      break;
    case "de":
    case "de-DE":
      switchLang("de-DE");

      break;
    case "fr":
    case "fr-FR":
    case "fr-BE":
      switchLang("fr-FR");
      break;
    case "da":
    case "da-DK":
      switchLang("da-DK");
      break;
    case "en":
    case "en-GB":
    case "en-UK":
    case "en-US":
      switchLang("en-UK");
      break;
    default:
      break;
  }
}

async function updateRelatie() {
  try {
    if (!saving.value && !!props.id) {
      saving.value = true;

      const url = `/api/consumersettings/v1/optin/relatie`;
      const data = {
        Optin: optin.value,
        NietBenaderen: nietBenaderen.value ?? false,
        RelatieType: relatieType.value,
      } as RelatieViewModel;

      await axios.post(url, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.id,
        },
      });
      issaved.value = true;
    }
  } catch (error) {
    console.log(error);
    haserror.value = true;
  } finally {
    saving.value = false;
  }
}

function onGroepChange(data: {
  permissie: string;
  field: CommunicatieMedium;
  waarde: OptInKeuze;
}): void {
  let curgroep = get(optin.value, "Autobedrijf");
  let curpermissie = get(curgroep, data.permissie) as PermissieViewModel;
  curpermissie[data.field] = data.waarde;
}

function allYes(): void {
  setAll(OptInKeuze.Ja);
}
function allNo(): void {
  setAll(OptInKeuze.Nee);
}
function setAll(keuze: OptInKeuze): void {
  ["Autobedrijf"].forEach((groep) => {
    let curgroep = get(optin.value, groep);
    ["Auto", "MerkModel", "Bedrijf", "Overig", "Enquetes"].forEach(
      (permissie) => {
        let curpermissie = get(curgroep, permissie) as PermissieViewModel;
        communicatieMedia.forEach((medium) => {
          curpermissie[medium.key] = keuze;
        });
      }
    );
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(RingLoader)
        ]))
      : _createCommentVNode("", true),
    (!_unref(showLoading) && !_unref(showError) && !issaved.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languageOptions, (language) => {
              return _createElementVNode("button", {
                key: language.locale,
                type: "button",
                class: "language-button",
                title: language.label,
                onClick: ($event: any) => (switchLang(language.locale))
              }, [
                _createElementVNode("img", {
                  src: language.flag,
                  class: "flag",
                  alt: language.label
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5)
            }), 64))
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("intro")), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("unknownHint")), 1),
          _createVNode(VueGroep, {
            label: _unref(t)('maintitle'),
            groep: optin.value.Autobedrijf,
            "niet-benaderen": nietBenaderen.value ?? false,
            onGroepchange: onGroepChange,
            onNietBenaderenChange: _cache[0] || (_cache[0] = (newVal) => (nietBenaderen.value = newVal))
          }, null, 8, ["label", "groep", "niet-benaderen"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(showLoading) && !issaved.value && !haserror.value)
      ? (_openBlock(), _createBlock(VueButton, {
          key: 2,
          type: "info",
          onClick: updateRelatie
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("save")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(showError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("algemeenError")), 1))
      : _createCommentVNode("", true),
    (issaved.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)("success")), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})